export default "__VITE_ASSET__8db54db8__"